module.exports = __webpack_public_path__ + "static/img/az3.8af59b1a.jpg";